export default "__VITE_ASSET__DdD6mh24__"